import React from 'react';
import { Card, Form, Row, Input, Col, notification } from 'antd';
import DF from '../../DisplayFramework/index';
import FormInput from 'components/FormInput';
import { changeMyPassword, changePwdRequest } from 'services/parametersService';
import SaveButton from 'components/SaveButton';
import { useQuery } from 'react-query';
import { getCurrentUser } from 'utils/APIUtils';
import { useForm } from 'antd/lib/form/Form';
import styles from './style.less';
import { LockOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

const ChangePassword = (props: { isInit?: boolean }) => {
  const history = useHistory();

  const { isInit } = props;

  const [form] = useForm();
  const { data: user } = useQuery(`getCurrentUser`, () =>
    getCurrentUser().then((res) => {
      form.setFieldsValue({ username: res.username });
      return res;
    })
  );

  const onFinish = (values: changePwdRequest) => {
    changeMyPassword({ userid: user.id, request: values }).then(
      (res) => {
        if (res.code === '200' && isInit) {
          notification.success({ message: res.message });
          localStorage.clear();
          history.push('/login');
        } else {
          notification.error({ message: res.message });
        }
      }
    );
  };

  return (
    <DF.Provider pagcode="changepwd">
      <Card
        title="Change Password"
        className={styles.loginCard}
        type="inner"
        bordered
      >
        <Form
          onFinish={onFinish}
          layout="vertical"
          form={form}
          initialValues={{ username: user?.username }}
        >
          <Row justify="center">
            <FormInput col xs={24} name="username">
              <Input disabled />
            </FormInput>
            <FormInput hidden={isInit} col xs={24} name="oldpassword">
              <Input.Password
                prefix={<LockOutlined />}
                size="large"
                type="password"
                placeholder="Password"
              
              />
            </FormInput>
            <FormInput col xs={24} name="newpassword"
              rules={[
                ({ getFieldValue }) => ({
                  
                  validator(_, value) {
                   const oldPassword = getFieldValue('oldpassword');
                   if (!oldPassword || oldPassword !== value) {
                     return Promise.resolve();
                   }
                   return Promise.reject(
                     new Error('Le nouveau mot de passe doit être différent de l\'ancien')
                   );
                  },
                 }),
              ]}
            >
            </FormInput>
            <Col xs={16} style={{ textAlign: 'right' }}>
              <SaveButton size="middle" comcode="save" />
            </Col>
          </Row>
        </Form>
      </Card>
    </DF.Provider>
  );
};

export default ChangePassword;
